import { useMutation, useQuery } from '@tanstack/react-query';

import { useSnackBar } from '@sbv-clients/ui-shared';
import { getApiErrorMessage } from '@sbv-clients/util-misc';

import { useApi } from '../index';

export const useSupportFacilityOptions = () => {
  const api = useApi();
  return useQuery({
    queryKey: ['support-facility-options'],
    queryFn: () =>
      api.supportApi.supportFacilityOptionsGet().then((r) => r.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useSupportEnterFacility = () => {
  const api = useApi();
  const { notifyError } = useSnackBar();

  return useMutation(
    (facilityId: string) =>
      api.supportApi
        .supportEnterFacilityFacilityIdPost({ facilityId })
        .then((r) => r.data),
    {
      onError: (error) => {
        notifyError(getApiErrorMessage(error));
      },
    }
  );
};
